export default{skeleton:"w_C9",rectangle:"w_DA",rounded:"w_DB"};
